'use client';

import { Button } from '@/modules/core/components/Button';
import {
    Form,
    FormActions,
    FormControl,
    FormItem,
    FormMessage,
} from '@/modules/core/components/Form';
import { FormLabel } from '@/modules/core/components/Form/FormLabel';
import { Input } from '@/modules/core/components/Input';
import { signIn } from 'next-auth/react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { signInBoxStyles as styles } from './styles';
import welcomeHeaderImage from './welcome_header_graphic.svg';

type SignInFormData = {
    username: string;
    password: string;
};

export function SignInBox() {
    const [signInError, setSignInError] = useState<string>();
    const router = useRouter();
    const [isBusy, setIsBusy] = useState(false);

    const {
        register,
        formState: { errors },
        handleSubmit,
    } = useForm<SignInFormData>({
        values: {
            username: '',
            password: '',
        },
    });

    const handleSignIn = handleSubmit(({ username, password }) => {
        setIsBusy(true);
        setSignInError('');
        signIn('sign-in', {
            username,
            password,
            redirect: false,
            callbackUrl: '/portal/organization',
        })
            .then((response) => {
                if (response?.ok) {
                    router.push('/portal/organization');
                } else {
                    setIsBusy(false);
                    setSignInError(
                        'The username or password you entered is incorrect',
                    );
                }
            })
            .catch((error) => {
                setIsBusy(false);
                setSignInError(
                    'The username or password you entered is incorrect',
                );
            });
    });

    return (
        <div className={styles.blockScope}>
            <div className="form__title">Welcome</div>
            <div className="form__subtitle">
                to the AAHRPP Online Accreditation Management System (OAMS)!
            </div>
            <hr />
            <Form>
                <FormItem>
                    <FormLabel>Email Address*</FormLabel>
                    {errors.username ? (
                        <FormMessage>{errors.username.message}</FormMessage>
                    ) : null}
                    <FormControl>
                        <Input
                            {...register('username', {
                                required: {
                                    value: true,
                                    message: 'Email Address is required',
                                },
                            })}
                            type="text"
                        />
                    </FormControl>
                </FormItem>
                <FormItem>
                    <FormLabel>Password*</FormLabel>
                    {errors.password ? (
                        <FormMessage>{errors.password.message}</FormMessage>
                    ) : null}
                    <FormControl>
                        <Input
                            {...register('password', {
                                required: {
                                    value: true,
                                    message: 'Password is required ',
                                },
                            })}
                            type="password"
                        />
                    </FormControl>
                </FormItem>
                <div className={styles.supportLinks}>
                    <Link
                        href="https://www.aahrpp.org/contact-us"
                        target="_blank"
                    >
                        Request an account
                    </Link>
                    <Link href="/reset-password">Forgot your password?</Link>
                </div>
                <div>
                    <p>{signInError}</p>
                </div>
                <FormActions>
                    <Button busy={isBusy} onClick={handleSignIn}>
                        Sign In
                    </Button>
                </FormActions>
            </Form>
        </div>
    );
}
